import React, { useState } from "react";
import { Moon, Sun } from "@phosphor-icons/react";

const KEY = "fleetly-theme";

export const ThemeToggle = () => {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  const toggle = () => {
    const next = !dark;
    document.documentElement.classList.toggle("dark", next);
    try { localStorage.setItem(KEY, next ? "dark" : "light"); } catch { /* ignore */ }
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", next ? "#0B1220" : "#0B1E3F");
    setDark(next);
  };
  return (
    <button
      onClick={toggle}
      className="w-9 h-9 flex items-center justify-center rounded-md hover:bg-muted transition-colors"
      title={dark ? "Tryb dzienny" : "Tryb nocny"}
      aria-label={dark ? "Tryb dzienny" : "Tryb nocny"}
      data-testid="theme-toggle-btn"
    >
      {dark ? <Sun className="w-5 h-5 text-amber-400" weight="fill" /> : <Moon className="w-5 h-5 text-muted-foreground" />}
    </button>
  );
};
